import { trpc } from '@/shared/api';

/** 면 사진과 합성 에셋(마스크·음영·안내선)은 같은 presign·confirm 엔드포인트를 용도로 나눠 쓴다. */
export const useFaceAssetMutations = () => ({
  presign: trpc.storage.presignUpload.useMutation().mutateAsync,
  confirm: trpc.storage.confirmFacePhotoUpload.useMutation().mutateAsync,
});
